var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSort = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 12.75a.75.75 0 0 0 .75-.75V4.81l1.22 1.22a.75.75 0 1 0 1.061-1.06l-2.49-2.491a.748.748 0 0 0-1.078-.001L1.97 4.97a.75.75 0 1 0 1.06 1.06l1.22-1.22V12c0 .414.336.75.75.75zm6 1a.748.748 0 0 1-.537-.227L7.97 11.03a.75.75 0 0 1 1.06-1.06l1.22 1.22V4a.75.75 0 1 1 1.5 0v7.19l1.22-1.22a.75.75 0 0 1 1.06 1.06l-2.5 2.5a.748.748 0 0 1-.53.22z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSort);
export default ForwardRef;